import { PackageDeployerFormController } from '../controller/PackageDeployerFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { PackageData } from '../../../types/package-data';
import { Observable } from 'rxjs';
import { CONNECT_TO_DEPLOYER_OPTIONS, DEFAULT_SUPA_PORT, DeployerDataResponse, DeployType } from '../types';
import { PackageActionContext } from '../../types/PackageActionContext';

export class PackageDeployerFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageDeployerFormController;
  public packageData: PackageData;
  public isRelay: boolean;
  private companyId: string | undefined;
  private _isInstallAgentDeployer = false;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageDeployerFormController,
    });
  }

  public async companyChangeHandler(): Promise<void> {
    await this.controller.companyChangeHandler();
  }

  public async setRelayCheckboxState(state: boolean): Promise<void> {
    this.isRelay = state;
    await this.controller.setRelayCheckboxState(state);
  }

  public get value(): DeployerDataResponse {
    const formValues: object = this.controller.view.formGroup.value;
    const useCustomEcs = formValues['settings']['useCustomECS'];
    let deployType =
      formValues['settings']['deployType'] !== CONNECT_TO_DEPLOYER_OPTIONS[DeployType.EndpointSecurityRelay].value
        ? CONNECT_TO_DEPLOYER_OPTIONS[DeployType.BitdefenderCloud].value
        : formValues['settings']['deployType'];
    if (this.dependencies.isCloud() && this.isInstallAgentDeployer) {
      deployType = CONNECT_TO_DEPLOYER_OPTIONS[DeployType.EndpointSecurityRelay].value;
    }

    const response: DeployerDataResponse = {
      updateLocation: this.controller.view.updateLocation,
      settings: {
        ecsHostname: useCustomEcs ? formValues['settings']['ecsHostname'] : this.controller.view.ecsHostname,
        useCustomECS: useCustomEcs,
        deployType: deployType,
      },
    };

    if (response.settings.deployType === CONNECT_TO_DEPLOYER_OPTIONS[DeployType.EndpointSecurityRelay].value) {
      const customHostname = this.controller.view.selectedRelayData.customHostname;
      const ip = this.controller.view.selectedRelayData.ip;
      response.updateLocation = customHostname + ':' + DEFAULT_SUPA_PORT;
      response.settings.ecsHostname = customHostname + ':' + DEFAULT_SUPA_PORT;

      if (customHostname === '') {
        response.settings.ecsHostname = ip + ':' + DEFAULT_SUPA_PORT;
        response.updateLocation = ip + ':' + DEFAULT_SUPA_PORT;
      }
      response.settings.supaId = this.controller.view.selectedRelayData._id;
    }

    return response;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup?.valid$;
  }

  public get formContext(): PackageActionContext {
    const context = this.getAttribute('context');

    if (!PackageActionContext.isValid(context)) {
      throw new Error(`PackagePanel context not valid: ${context}`);
    }

    return context as PackageActionContext;
  }

  public set formContext(context: PackageActionContext) {
    this.setAttribute('context', context);
  }

  public async setPackageData(packageData: PackageData): Promise<void> {
    this.packageData = packageData;
  }

  public setCompanyId(companyId: string | undefined) {
    this.companyId = companyId;
  }

  public getCompanyId(): string | undefined {
    return this.companyId;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  public set isInstallAgentDeployer(isInstallAgentDeployer: boolean) {
    this._isInstallAgentDeployer = isInstallAgentDeployer;
  }

  public get isInstallAgentDeployer(): boolean {
    return this._isInstallAgentDeployer;
  }

  public get deployerType(): number {
    return this.controller.getDeployerType();
  }
}
